import { render } from "./Maintenance.vue?vue&type=template&id=d746e2f6"
const script = {}

import exportComponent from "/home/peter/new-demo-tool/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__